export default {
  dtInventory: {
    label: 'ruptureIrc.dtInventory',
    field: 'dtInventory',
    type: 'date',
    align: 'center',
    customWidth: 85,
    fixed: true,
    render: true,
  },
  dsBranch: {
    label: 'ruptureIrc.dsBranch',
    field: 'dsBranch',
    type: 'general',
    align: 'left',
    disableOrder: true,
    customWidth: 120,
    fixed: true,
    render: true,
  },
  cdSection: {
    label: 'ruptureIrc.section',
    field: 'cdSection',
    type: 'general',
    align: 'left',
    disableOrder: true,
    customWidth: 120,
    fixed: true,
    render: true,
  },
  cdLm: {
    label: 'ruptureIrc.cdLm',
    field: 'cdDeposit',
    type: 'general',
    align: 'left',
    disableOrder: true,
    customWidth: 70,
    fixed: true,
    render: true,
  },
  dsProduct: {
    label: 'ruptureIrc.dsProduct',
    field: 'dsProduct',
    type: 'general',
    align: 'left',
    disableOrder: true,
    fixed: true,
    render: true,
  },
  c50: {
    label: 'ruptureIrc.c50',
    field: 'c50',
    type: 'decimal',
    align: 'left',
    disableOrder: true,
    fixed: false,
    render: true,
  },
  c50Counted: {
    label: 'ruptureIrc.c50Counted',
    field: 'c50Counted',
    type: 'decimal',
    align: 'left',
    disableOrder: true,
    fixed: false,
    render: true,
  },
  qtDifference: {
    label: 'ruptureIrc.qtDifference',
    field: 'qtDifference',
    type: 'decimal',
    align: 'left',
    disableOrder: true,
    fixed: false,
    render: true,
  },
  dpacValue: {
    label: 'ruptureIrc.dpac',
    field: 'dpacValue',
    type: 'currency',
    align: 'left',
    disableOrder: true,
    customWidth: 100,
    fixed: false,
    render: true,
  },
  vlDifference: {
    label: 'ruptureIrc.vlDifference',
    field: 'vlDifference',
    type: 'currency',
    align: 'left',
    disableOrder: true,
    fixed: false,
    render: true,
  },
  accurrancy: {
    label: 'ruptureIrc.accurrancy',
    field: 'accurrancy',
    type: 'general',
    align: 'left',
    disableOrder: true,
    customWidth: 90,
    fixed: false,
    render: true,
  },
  integrated: {
    label: 'ruptureIrc.integrated',
    field: 'integrated',
    type: 'general',
    align: 'left',
    disableOrder: true,
    customWidth: 90,
    fixed: false,
    render: true,
  },
  dsJustification: {
    label: 'ruptureIrc.dsJustification',
    field: 'dsJustification',
    type: 'general',
    align: 'left',
    disableOrder: true,
    fixed: false,
    render: true,
  },
  ldap: {
    label: 'ruptureIrc.ldap',
    field: 'ldap',
    type: 'general',
    align: 'left',
    disableOrder: true,
    fixed: false,
    render: true,
  },
  warehouse: {
    label: 'ruptureIrc.warehouse',
    field: 'warehouse',
    type: 'general',
    align: 'left',
    disableOrder: true,
    customWidth: 90,
    fixed: false,
    render: true,
  },
  provider: {
    label: 'ruptureIrc.provider',
    field: 'provider',
    type: 'general',
    align: 'left',
    disableOrder: true,
    fixed: false,
    render: true,
  },
}
